export default "__VITE_ASSET__BcJHuOXS__"